module.exports = __webpack_public_path__ + "static/media/COURSE_CONTENTS.0b5ef05c.pdf";